import styled from "styled-components";

import {
  Block,
  Anchor,
} from '../../../styles'

export const ParsedHTMLContainer = styled(Block)``
export const ParsedHTMLAnchor = styled(Anchor)``
